import {useContext} from "react";
import AuthContext from "../context/AuthContext";
import './_style.css'

export default function Login() {

    let {loginUser} = useContext(AuthContext)

    // function onSubmit(event: any) {
    //     console.log('Form submitted:', event.target.action)
    //     event.preventDefault()
    // }

    return (

        <div className="login-container">

            <div className="login-form-container">

                <form onSubmit={loginUser}>
                    <div className="login-form">
                        <div className="login-form-header">icecat &nbsp;feeds</div>
                        <div className="login-form-block">
                            <input type="text" name="username" placeholder="Username" className="login-form-input"/>
                            <input type="password" name="password" placeholder="Password" className="login-form-input"/>
                            <button type="submit" value="Submit" className="btn-login-submit">LOGIN</button>
                        </div>
                    </div>
                </form>

            </div>

            <div className="login-footer">© 2022-2025 Icecat.biz</div>

        </div>


    )
}